<template>
  <v-container fluid :class="mobile ? 'pa-2' : 'pa-4'" class="fill-height">
    <v-row class="justify-center align-center fill-height">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3">
        <login-form />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { useDisplay } from "vuetify";
import { useApp } from "@/composables/useApp.js";
import LoginForm from "@/components/LoginForm.vue";

const { isAuthenticated } = useApp();

const { mobile } = useDisplay();
</script>
